import { Button } from "primereact/button";
import React, { useState } from "react";
import { APP_VERSION } from './service/Config'

const AppFooter = () => {
    const [showScroll, setShowScroll] = useState(false)
    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 400) {
            setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 400) {
            setShowScroll(false)
        }
    };
    window.addEventListener('scroll', checkScrollTop)

    return (
        <>
            <div
                className="layout-footer"
                style={{
                    color: "#f8f9fa",
                    bottom: 0,
                    width: "auto",
                    height: "5.5%",
                    marginLeft: -16,
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                <div className="p-grid" style={{ marginTop: '-0.8rem' }}>
                    <div className="p-col-8 " style={{ textAlign: "left", marginTop: "auto", padding: '0rem' }}>
                        <span style={{ textAlign: "left", justifyContent: "center", marginLeft: 25 }}>พัฒนาโดย: </span>
                        <span style={{ textAlign: "left", justifyContent: "center", marginLeft: 5 }}>การประปานครหลวง Version {APP_VERSION}</span>
                    </div>

                    <div className="p-col-4 footer-icons " style={{ textAlign: "right" }}>
                        <span style={{ textAlign: "left", justifyContent: "end", marginLeft: 5 }}>รองรับเบราว์เซอร์ : </span>
                        <img alt="babylon-layout" src="assets/layout/images/chrome_icon.png" style={{ width: 25, height: 25, marginTop: '6px', marginBottom: '-7px' }} />
                        <img alt="babylon-layout" src="assets/layout/images/edge_icon.png" style={{ width: 25, height: 25, marginTop: '6px', marginBottom: '-7px' }} />
                        <img alt="babylon-layout" src="assets/layout/images/firefox_icon.png" style={{ width: 25, height: 25, marginTop: '6px', marginBottom: '-7px' }} />
                    </div>
                </div>
            </div>
            {/* style={{height: 40, display: showScroll ? 'flex' : 'none'}} */}
            <div className="___goToTop" style={{
                alignItems: 'center',
                display: showScroll ? 'flex' : 'none',
                position: 'fixed',
                bottom: '20px',
                right: '30px',
                zIndex: 99,
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                borderRadius: '4px',
            }} >
                <Button
                    icon="pi pi-arrow-up"
                    className="p-button-rounded"
                    style={{ width: 50, height: 50, marginBottom: 33 }}
                    onClick={() => {
                        window.scroll({ top: 0, behavior: "smooth" });
                    }}
                    tooltip="กลับสู่ด้านบน"
                    tooltipOptions={{ position: "top" }}
                />
            </div>
        </>
    );
};

export default AppFooter;
